module.exports = __webpack_public_path__ + "p4_img4.jpg?b7e580de08cb5ac9d8a8d6043d90d7c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img4.jpg
// module id = 111
// module chunks = 0